import type { Segment } from '@fixter/i18n';
import { orderBy } from 'lodash';
import type { CmsSymptomItem } from '$cms/types';
import { fetchSymptomCollectionData } from '$server/modules/cms/fetchSymptomCollectionData';

export const fetchSymptoms = (segment: Segment, preview = false): Promise<CmsSymptomItem[]> =>
  fetchSymptomCollectionData({
    filter: {
      key: 'popularity',
      operator: 'gte',
      value: 0,
    },
    limit: 100,
    segment,
    preview,
  }).then((collection) => orderBy(collection, 'popularity', 'asc'));
